<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<div #ref>
	<ng-content select="[customUI]"></ng-content>
</div>

<!-- show only if we have customUI -->
<ng-container *ngIf="ref.hasChildNodes()">
	<!-- actual file input/upload, invisible -->
	<input
		#customFileInput
		type="file"
		class="input-upload"
		automationId="inputUpload"
		accept="{{ acceptedFileTypes.join() }}"
		[attr.multiple]="allowMultiple ? 'multiple' : null"
		(change)="onFileChange($event)"
	/>
</ng-container>

<!-- show only if we don't have customUI -->
<ng-container *ngIf="!ref.hasChildNodes()">
	<div class="upload-container">
		<mat-form-field class="upload-field">
			<mat-label>{{ placeholder }}</mat-label>
			<input
				matInput
				[formControl]="uploadedFilenames"
				(click)="fileInput.click()"
				automationId="ticketDataFile"
				autocomplete="off"
				spellcheck="false"
			/>

			<!-- actual file input/upload, invisible -->
			<input
				#fileInput
				type="file"
				class="file-upload"
				automationId="fileUpload"
				accept="{{ acceptedFileTypes.join() }}"
				[attr.multiple]="allowMultiple ? 'multiple' : null"
				(change)="onFileChange($event)"
			/>

			<!-- hint will display if there are no error -->
			<mat-hint>{{ hintMessages.get(uploadState) }}</mat-hint>
			<mat-error>{{ getErrorMessage() }}</mat-error>
		</mat-form-field>

		<div class="upload-button" #uploadButton>
			<button
				mat-stroked-button
				color="primary"
				automationId="uploadButton"
				[disabled]="disable"
				(click)="fileInput.click()"
			>
				{{ buttonText | uppercase }}
			</button>
		</div>
	</div>
</ng-container>
